import classNames from 'classnames/bind';
import { DetailedHTMLProps, forwardRef, HTMLAttributes, Ref } from 'react';
import styles from './button.module.scss';

const classesContext = classNames.bind(styles);

function ButtonTab(
  {
    children,
    isActive,
    className,
    ...restProps
  }: { isActive: boolean } & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  ref: Ref<HTMLDivElement>
): JSX.Element {
  return (
    <div
      ref={ref}
      className={classesContext([
        'button',
        'button_primary',
        'button__tab',
        'tab',
        { tab__active: isActive },
        className
      ])}
      {...restProps}
    >
      {children}
    </div>
  );
}

export default forwardRef(ButtonTab);
